/**
 * @fileoverview Login layout
 *
 * Purpose: Full-screen shell for the login route. The Morgan logo stays
 * pinned to the top left; the auth form (rendered by the child route) is
 * centred in the remaining space.
 * URL: /login
 */

import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { Logo } from "@/ui/layout";
import { useConvexAuth } from "convex/react";

const HOME_PATH = "/";

export const Route = createFileRoute("/_app/login/_layout")({
  component: LoginLayout,
});

function LoginLayout() {
  const { isAuthenticated, isLoading } = useConvexAuth();
  if (isLoading && !isAuthenticated) {
    return null;
  }
  return (
    <div className="relative flex h-screen w-full bg-card">
      <Link
        to={HOME_PATH}
        className="absolute left-6 top-6 z-10 flex items-center lg:left-10 lg:top-10"
      >
        <Logo width={140} height={36} />
      </Link>
      <div className="flex h-full w-full flex-col">
        <Outlet />
      </div>
    </div>
  );
}
